export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ArticleListItem.vue?vue&type=template&id=a2f8453a&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/ArticleListItem.vue?vue&type=template&id=a2f8453a&
// module id = 37
// module chunks = 0 2 3 4 6